import { render, staticRenderFns } from "./KT-ProjectForecast.vue?vue&type=template&id=dd25e6d8&scoped=true&"
import script from "./KT-ProjectForecast.vue?vue&type=script&lang=js&"
export * from "./KT-ProjectForecast.vue?vue&type=script&lang=js&"
import style0 from "./KT-ProjectForecast.vue?vue&type=style&index=0&id=dd25e6d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd25e6d8",
  null
  
)

export default component.exports